import { documentExtensions } from '../attachments/attachmentsApi';
import type { ProfileUpdateMode } from './types';

export const KEY_CREDITS_GRID_FIELD = 'keyCredits' as const;

export const KEY_CREDITS_DISPLAY_MODE = {
    comma: 'comma',
    chip: 'chip',
    pipe: 'pipe',
    lineBreak: 'lineBreak'
} as const;

export const KEY_CREDITS_WRAP_LIMIT = {
    min: 1,
    max: 5,
    default: 3
} as const;

export const KEY_CREDITS_COLUMN_MENU_SELECT_MIN_WIDTH = 150;
export const KEY_CREDITS_COLUMN_MENU_DISPLAY_MODE_ORDER = 27;
export const KEY_CREDITS_COLUMN_MENU_WRAP_LIMIT_ORDER = 28;
export const KEY_CREDITS_COLUMN_MENU_MANAGE_PANEL_ORDER = 29;

export const KEY_CREDITS_DROPDOWN_WIDTH_PADDING_PX = 64;
export const KEY_CREDITS_DROPDOWN_MAX_WIDTH_EXTRA_PX = 48;
/** Single-click popover delay when edit-on-double-click is enabled (avoids popover stealing 1st click of dbl-click). */
export const KEY_CREDITS_POPOVER_DEFER_MS = 300;

/** Max upload size for Key Credits AI source documents (10 MB). */
export const KEY_CREDITS_AI_MAX_UPLOAD_BYTES = 10 * 1024 * 1024;

/** MIME types accepted by the Key Credits AI upload dropzone. */
export const KEY_CREDITS_AI_ACCEPTED_MIME = ['application/pdf', ...documentExtensions].join(',');

export const PROFILE_UPDATE_MODE_OPTIONS: ProfileUpdateMode[] = ['all', 'selected', 'none'];

export const MANUAL_PROFILE_UPDATE_MODE_OPTIONS: ProfileUpdateMode[] = ['all', 'none'];

export const IMPORT_PROFILE_UPDATE_MODE_OPTIONS: ProfileUpdateMode[] = ['all', 'selected', 'none'];

export const PROFILE_UPDATE_MODE_TOKENS: Record<ProfileUpdateMode, string> = {
    all: 'shortlist.key.credits.ai.profile.update.all',
    selected: 'shortlist.key.credits.ai.profile.update.selected',
    none: 'shortlist.key.credits.ai.profile.update.none'
};

export const MANUAL_PROFILE_UPDATE_MODE_TOKENS: Partial<Record<ProfileUpdateMode, string>> = {
    all: 'shortlist.key.credits.manual.profile.update.all'
};

export const IMPORT_PROFILE_UPDATE_MODE_TOKENS: Partial<Record<ProfileUpdateMode, string>> = {
    all: 'shortlist.key.credits.import.profile.update.all'
};
